export default "__VITE_ASSET__mMB2noP3__"